import Connector from './connector';
import { CopyContainerModal as Component } from './CopyContainerModal';
import { ConnectorProps } from './CopyContainerModal.proptypes';

export interface CopyContainerModalProps extends Omit<ConnectorProps, 'component'> {}

export const CopyContainerModal = (props: CopyContainerModalProps) => <Connector {...props} component={Component} />;
